import { Container, Row, Col } from "reactstrap";
import Link from "next/link";
import Image from "next/image";
import { BsChevronRight } from "react-icons/bs";

//local imports
import classes from "@/styles/generic/hero.module.css";
import { heroImg1 } from "@/utils/images";
import { hero } from "@/utils/content";
import { routes } from "@/utils/routes";

export default function Hero({ hideSeeMore = false }) {
  return (
    <>
      <div className={classes.container}>
        <Container>
          <Row>
            <Col
              className={`pt-5 pb-5 text-center ${classes.col1}`}
              xs={12}
              lg={4}
            >
              <Image src={heroImg1} alt={heroImg1} height={190} width={200} />
            </Col>
            <Col
              className={`pt-5 mt-3 pb-5 text-center ${classes.col2}`}
              xs={12}
              lg={8}
            >
              <div
                className={`${classes.heading} mx-auto text-white`}
                dangerouslySetInnerHTML={{ __html: hero.en.heading }}
              />
            </Col>
          </Row>
        </Container>
      </div>
      {!hideSeeMore && (
        <div className={`${classes.heroFooter} text-center`}>
          <Link
            href={routes.contestAirmilesGiveaway}
            className={classes.heroFooterBtn}
          >
            {hero.en.buttonText} &nbsp;
            <BsChevronRight />
          </Link>
        </div>
      )}
    </>
  );
}
